module.exports = __webpack_public_path__ + "static/media/icon-covid-global-active.625d8f56.svg";